import React, { Component } from "react"
import Slider from "react-slick"
import Svg from "../../shared/_svgs/svg"
import TruncateMarkup from "react-truncate-markup"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import Reveal from "react-awesome-reveal"

export default class Carousel extends Component {
  constructor(props) {
    super(props)

    this.state = {
      slides: props.carouselItems,
    }
  }

  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
  }

  render() {
    let style = {}

    var settings = {
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    const innerWidth = window.innerWidth

    if (innerWidth < 1590 || (this.state.slides && this.state.slides.length > 3)) {
      style = { "--slick-max-width": "1020px" }
    }

    let slidesInView = 3
    if (innerWidth < 950) {
      settings.slidesToShow = 2
      if (innerWidth < 680) {
        settings.slidesToShow = 1
        slidesInView = 2
      }
      if (innerWidth < 350) {
        slidesInView = 1
      }
    } else {
      settings.slidesToShow = 1
      slidesInView = 2
      if (innerWidth >= 1050) {
        settings.slidesToShow = 2
        slidesInView = 3
      }
      if (innerWidth >= 1550) {
        settings.slidesToShow = 3
      }
    }

    if (this.state.slides && this.state.slides.length <= 3) {
      settings.arrows = false
    }

    const titleAnimationType = SelectionFactoryHelper.getFromSelectionFactory(this.props.titleAnimation.type)
    const headingAnimationType = SelectionFactoryHelper.getFromSelectionFactory(this.props.headingAnimation.type)

    return (
      <div className="carousel-block" style={style}>
        <div className="stationary">
          {this.props.title ? (
            <Reveal
              keyframes={titleAnimationType ? titleAnimationType : null}
              className={titleAnimationType ? "" : "disable-reveal"}
              duration={this.props.titleAnimation.duration}
              delay={this.props.titleAnimation.delay}
              fraction={1}
              triggerOnce
            >
              <div className={`infohead`}>{this.props.title}</div>
            </Reveal>
          ) : (
            ""
          )}
          {this.props.headline ? (
            <Reveal
              keyframes={headingAnimationType ? headingAnimationType : null}
              className={headingAnimationType ? "" : "disable-reveal"}
              duration={this.props.headingAnimation.duration}
              delay={this.props.headingAnimation.delay}
              fraction={1}
              triggerOnce
            >
              <div className={`heading`} dangerouslySetInnerHTML={{ __html: this.props.headline }}></div>
            </Reveal>
          ) : (
            ""
          )}
          {this.props.text ? (
            <div
              className={`maintext ${!(this.props.link && this.props.linkText) ? "maintext-no-link" : ""}`}
              dangerouslySetInnerHTML={{ __html: this.props.text }}
            ></div>
          ) : (
            ""
          )}
          {window.innerWidth >= 950 && this.props.link && this.props.linkText ? (
            <a className={"see-all-link"} href={this.props.link}>
              <Svg iconName={"arrowright-slim"} fillColor={"none"} renderContainer={false} />
              {this.props.linkText}
            </a>
          ) : (
            ""
          )}
        </div>
        <Slider {...settings}>
          {this.state.slides &&
            this.state.slides.length > 0 &&
            this.state.slides.map((item, index) => {
              return <CarouselItem key={index} {...item} {...item.animation} index={index} slidesInView={slidesInView} />
            })}
        </Slider>
        {window.innerWidth < 950 && this.props.link && this.props.linkText ? (
          <a className={"see-all-link"} href={this.props.link}>
            <Svg iconName={"arrowright-slim"} fillColor={"none"} renderContainer={false} />
            {this.props.linkText}
          </a>
        ) : (
          ""
        )}
      </div>
    )
  }
}

class CarouselItem extends Component {
  render() {
    let animationType = SelectionFactoryHelper.getFromSelectionFactory(this.props.type)
    if (animationType === undefined) {
      animationType = null
    } else {
      if (this.props.index >= this.props.slidesInView) {
        animationType = null
      }
    }
    return (
      <Reveal
        keyframes={animationType}
        className={animationType ? "" : "disable-reveal"}
        duration={this.props.duration}
        delay={this.props.delay}
        fraction={0}
        triggerOnce
      >
        <a href={this.props.link ? this.props.link : undefined}>
          {this.props.image ? <img src={this.props.image} /> : ""}
          <div className="textarea">
            {this.props.headline ? <h2>{this.props.headline}</h2> : ""}
            {this.props.text ? (
              <TruncateMarkup lines={4} ellipsis={"..."}>
                <span>{this.props.text}</span>
              </TruncateMarkup>
            ) : (
              ""
            )}
            {this.props.link && this.props.linkText ? (
              <div className="see-all-link">
                <Svg iconName={"arrowright-slim"} fillColor={"none"} renderContainer={false} />
                {this.props.linkText}
              </div>
            ) : (
              ""
            )}
          </div>
        </a>
      </Reveal>
    )
  }
}
